import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget } from '../../../widgets';
import FiltrosEstudiantesDocenteComponent from './components/FiltrosEstudiantesDocente';
import ListadoEstudiantesDocente from './components/ListadoEstudiantesDocente';

const EstudiantesDocenteView = () => {
  const loginStore = Redux.useSelector((state) => state.login);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [isFiltros, setIsFiltros] = React.useState(false);

  React.useEffect(() => {
    if (!loginStore.isAdminTeacher) {
      if (
        !estudiantesStore.paramsEstudiantesDocente.materia ||
        !estudiantesStore.paramsEstudiantesDocente.seccion
      ) {
        setIsFiltros(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}></Grid>
      <Grid item md={12}>
        <ListadoEstudiantesDocente />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosEstudiantesDocenteComponent />
      </DrawerWidget>
    </Grid>
  );
};

export default EstudiantesDocenteView;
